import { ApplicationContainer } from "@/components/ApplicationContainer";
import "@/styles/globals.css";
import "@mantine/core/styles/global.css";

import "@mantine/core/styles/Button.css";

import "@mantine/core/styles.layer.css";
import "@mantine/carousel/styles.css";
// ... other styles
import { MantineProvider, createTheme, DEFAULT_THEME } from "@mantine/core";
import { useRouter } from "next/router";
import Head from "next/head";
import * as gtag from "../lib/gtag";
import { initAiReferral } from "../lib/aiReferral";
import { initWhatsAppTracking } from "../lib/whatsappTracking";
import { useEffect } from "react";
import WhatsAppButton from "@/components/WhatsAppButton";
export default function App({ Component, pageProps }) {
  const router = useRouter();
  useEffect(() => {
    initAiReferral();
    return initWhatsAppTracking();
  }, []);
  useEffect(() => {
    const handleRouteChange = (url) => {
      gtag.pageview(url);
    };

    router.events.on("routeChangeComplete", handleRouteChange);

    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, [router.events]);
  return (
    <div>
      <Head>
        {/* <meta
          name="viewport"
          content="minimum-scale=1, initial-scale=1, width=device-width"
        /> */}
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Head>
      <MantineProvider withCssVariables theme={createTheme({ ...DEFAULT_THEME, fontFamily: "'Heebo', sans-serif", headings: { fontFamily: "'Rubik', 'Heebo', sans-serif", fontWeight: '800' } })}>
        <ApplicationContainer>
          <Component {...pageProps} />
          <WhatsAppButton />
        </ApplicationContainer>
      </MantineProvider>
    </div>
  );
}
